// modules
import React from 'react';

// local
import { Feature } from './components';
import './FeatureList.css';

const features = [
    {
        imgUrl: '/_img/data.svg',
        text: 'Organized historical data and reports so you can identify trends in your past behavior.'
    },
    {
        imgUrl: '/_img/planning.svg',
        text: 'Simple tools for planning future trades so you can manage risk effectively.'
    },
    {
        imgUrl: '/_img/import.svg',
        text: 'Painless import of your trading history so you can focus on making the data work for you.'
    }
];


const FeatureList = () => (
  <div className={ 'FeatureList__wrapper' }>
    { features.map(({ imgUrl, text }, index) => <Feature key={ index } imgUrl={ imgUrl } text={ text } />) }
  </div>
);

export default FeatureList;



// WEBPACK FOOTER //
// ./src/components/FeatureList/index.js